import Breadcrumb from './Breadcrumb/Breadcrumb';
import ProgressBar from './ProgressBar/ProgressBar';
import Timeline from './Timeline/Timeline';

import './ProcessSidebar.css';

export default function ProcessSidebar() {
	return (
		<div id="process-sidebar">
			<Breadcrumb />
			<ProgressBar />
			<Timeline />
		</div>
	);
}
